import { logger } from '@/lib/logger';
import { CATALOG_STALE_TIME, queryKeys } from '@/lib/queryClient';
import { getCourseBySlug } from '@/supabase/services/courses';
import type { Course } from '@/types';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

export function useCourse(courseSlug: string): UseQueryResult<Course, Error> {
  return useQuery({
    queryKey: queryKeys.course.bySlug(courseSlug),
    queryFn: async () => {
      logger.debug('[Cache] Fetching course:', courseSlug);
      return getCourseBySlug(courseSlug);
    },
    staleTime: CATALOG_STALE_TIME,
    enabled: !!courseSlug,
  });
}

